import { create }from 'zustand';
import { devtools } from 'zustand/middleware';
import { Prices, Rates } from '../models/CurrencyPair';

export const priceStore = create<Prices>()(
    devtools((set) => ({
        pricesGeneratedAt: '',
        prices: [],
    }))
)

export const updatePrices = (updatedPrices: Rates[]) => {
    priceStore.setState((state : Prices) => ({
        prices: updatedPrices
    }))
}

export const updateTime = (date: string) => {
    priceStore.setState(() => ({
        pricesGeneratedAt: date
    }))
}
